import {
  UPDATE_PRICE_TREND,
  ALL_REAL_ESTATES_FROM_OMA_RECEIVED,
  SET_SELECTED_REAL_ESTATE,
  SET_DID_COMPLETE_SURVEY,
  UPDATE_DESIRED_PRICE,
  REFRESH_ALL_REAL_ESTATES,
} from './actions.js';
import localStorage from '../../utils/localStorage';
import { DID_COMPLETE_SURVEY } from '../../utils/globals';

export const initialState = {
  didCompleteSurvey: Boolean(localStorage.getItem(DID_COMPLETE_SURVEY)),
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REFRESH_ALL_REAL_ESTATES: {
      const previousSelectedRealEstate = state.selectedRealEstate;
      const newSelectedRealEstate = action.allRealEstates.find(
        (x) => x.realEstateId === previousSelectedRealEstate.realEstateId,
      );
      return { ...state, myPropertyAllRealEstates: action.allRealEstates, selectedRealEstate: newSelectedRealEstate };
    }
    case ALL_REAL_ESTATES_FROM_OMA_RECEIVED:
      return { ...state, myPropertyAllRealEstates: [...action.allRealEstates] };
    case UPDATE_PRICE_TREND:
      return Object.assign({}, state, { priceTrend: action.priceTrend });
    case SET_SELECTED_REAL_ESTATE:
      return { ...state, selectedRealEstate: { ...action.realEstate } };
    case UPDATE_DESIRED_PRICE:
      return Object.assign({}, state, { desiredPrice: action.desiredPrice });
    case SET_DID_COMPLETE_SURVEY:
      localStorage.setItem(DID_COMPLETE_SURVEY, true);
      return { ...state, didCompleteSurvey: true };
    default:
      return state;
  }
};

export default reducer;
